webpackJsonp([209199484147410],{

/***/ 186:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'Siljekvarnsvägen',
	    description: 'Siljekvarnsvägens vägförening.',
	    siteUrl: 'https://siljekvarnsvagen.se',
	    author: 'Siljekvarnsvägen'
	  },
	  pathPrefix: '/',
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      path: __dirname + '/src/pages',
	      name: 'pages'
	    }
	  }, {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: [{
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 750,
	          linkImagesToOriginal: false,
	          wrapperStyle: 'margin-bottom: 1.0725rem;'
	        }
	      }, {
	        resolve: 'gatsby-remark-responsive-iframe',
	        options: {
	          wrapperStyle: 'margin-bottom: 1.0725rem'
	        }
	      }, 'gatsby-remark-prismjs', 'gatsby-remark-copy-linked-files', 'gatsby-remark-smartypants']
	    }
	  }, {
	    resolve: 'gatsby-plugin-netlify',
	    options: {
	      mergeSecurityHeaders: true,
	      mergeLinkHeaders: true,
	      mergeCachingHeaders: true
	    }
	  }, 'gatsby-plugin-catch-links', 'gatsby-plugin-offline', 'gatsby-plugin-react-helmet', 'gatsby-plugin-react-next', 'gatsby-plugin-sass', 'gatsby-plugin-sharp', 'gatsby-plugin-sitemap', 'gatsby-transformer-sharp']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(103);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyConfig = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_React$Component) {
	  _inherits(Profile, _React$Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Profile.prototype.render = function render() {
	    var pathPrefix =  false ? '' : ("");
	    var title = 'Om';
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: title + ' | ' + (0, _get2.default)(_gatsbyConfig.siteMetadata, 'title'),
	        meta: [{ property: 'og:title', content: title }, { property: 'og:type', content: 'website' }, {
	          property: 'og:description',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'description')
	        }, {
	          property: 'og:url',
	          content: (0, _get2.default)(_gatsbyConfig.siteMetadata, 'siteUrl') + '/om'
	        }]
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Om v\xE4gf\xF6reningen'
	          )
	        )
	      )
	    );
	  };
	
	  return Profile;
	}(_react2.default.Component);
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-om-index-jsx-528df9de25f746c8d7d2.js